import React, { createContext, useState } from "react";

// Create the contexts
export const SelectionContext = createContext();
export const NotificationContext = createContext();
export const UpdateContext = createContext();
export const NotificationlistContext = createContext();
// Context provider component
const StoreContext = ({ children }) => {
  // State for location
  const [location, SetLocation] = useState([]);
  // State for people
  const [people, SetPeople] = useState([]);
  // State for count
  const [count, setCount] = useState([]);

  const [listupdate, setListupdate] = useState(false);

  const [notification, setNotification] = useState([]);

  return (
    <SelectionContext.Provider
      value={{ location, SetLocation, people, SetPeople }}
    >
      <NotificationContext.Provider value={{ count, setCount }}>
        <UpdateContext.Provider value={{ listupdate, setListupdate }}>
          <NotificationlistContext.Provider value={{ notification, setNotification }}>
            {children}
          </NotificationlistContext.Provider>
        </UpdateContext.Provider>
      </NotificationContext.Provider>
    </SelectionContext.Provider>
  );
};

export default StoreContext;
